import React from "react";

// components
import {
    License,
    SidebarWrapper,
    History
} from "frontend/components/fort/mod/core/Sidebar/index.js";
import Tags from "./Tags";
import EuoCheckbox from "./EuoCheckbox";

import Overview from "./Overview";

const PhotoModQueueSidebar = () => {
    return (
        <SidebarWrapper>
            <Overview />
            <Tags />
            <License>
                <EuoCheckbox />
            </License>
            <History />
        </SidebarWrapper>
    );
};

export default PhotoModQueueSidebar;
